import { Button, Drawer, Form, Input, Layout, message, Popconfirm, Popover, Select, Spin } from 'antd';
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import * as CHALLENGES_SERVICES from "api/services/challenges/challenges.services";
import { findLevelsById } from "api/services/levels/levels.services";
import * as ROOMS_SERVICES from "api/services/rooms/rooms.services";
import { FLAGS, StatusCode } from 'common/enums';
import Breadcrumbs from 'components/breadcrumbs';
import GroupClassesContent from 'components/classroomComponents/GroupClassesContent/GroupClassesContent';
import ClassroomHeader from 'components/classroomComponents/Header/Header';
import NavigationTabs from 'components/classroomComponents/NavigationTabs/NavigationTabs';
import ClassroomSidebar from 'components/classroomComponents/Sidebar/Sidebar';
import { TabType } from 'components/classroomComponents/types';
import { Moment } from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { studentParser } from 'screens/student/RoomStudent/assets/utils/converters';
import AppScreen from 'screens/teacher/ScreenWithSidebar';
import { displayDrawerAdsSpecific } from 'store/adventissements';
import { setIsContributionUpdated, setNewInvitationSent } from 'store/app/appSlice';
import { setChatReceiverId, setSelectUserChat, toggleAppChat } from 'store/AppChat/appChat';
import { useFindRoomMutation } from 'store/services/chat';
import { Icourses, useGetAllQuizzMutation } from 'store/services/teacher/courses';
import * as CHALLENGE_SERVICES from "../../../api/services/challenges/challenges.services";
import * as TOPICS_SERVICES from "../../../api/services/topics/topics.services";
import ArrowBack from "../../../assets/images/app/arrow_back.svg";
import Delete from "../../../assets/images/app/delete_article.svg";
import MessageIcon from "../../../assets/images/app/message_icon.png";
import MoreOptions from "../../../assets/images/app/options_icon.svg";
import IconSearch from "../../../assets/images/app/search.svg";
import DrawerHistorique from "../studentCalendar/components";
import './ClassDetails.css';

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;

const Room: React.FC = () => {

  const { id } = useParams();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [activeTab, setActiveTab] = useState<TabType>('reservations');
  const [classData, setClassData] = useState<any>();
  const { newInvitationSent } = useSelector((state) => state.app);
  const isContributionUpdated = useSelector((state) => state.app);
  const [loading, setLoading] = useState<boolean>(true);
  const [filteredStudents, setFilteredStudents] = useState<any>([]);
  const [studentsData, setStudentsData] = useState<any>([]);
  const [findRoom, { data: dataFindRoom, isSuccess }] = useFindRoomMutation();
  const [showAddClasse, setShowAddClasse] = useState<boolean>(false);
  const [showDrawerCreProf, setShowDrawerCreProf] = useState<boolean>(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [isDrawerStudentsVisible, setIsDrawerStudentsVisible] = useState(false);
  const [openDrawerHistorique, setOpenDrawerHistorique] = useState<boolean>(false);
  const [openDrawerPublications, setOpenDrawerPublications] = useState(false);
  const [isDrawerChallengesHistoryVisible, setIsDrawerChallengesHistoryVisible] = useState(false);
  const [publicationData, setPublicationData] = useState<any>();
  const [challenges, setChallenges] = useState([]);
  const [challengesHistory, setChallengesHistory] = useState([]);
  const [filteredChallenges, setFilteredChallenges] = useState([]);
  const [challenge, setChallenge] = useState<any>();
  const [pieData, setPieData] = useState([]);
  const [barData, setBarData] = useState([]);
  const [challengePercentage, setChallengePercentage] = useState<any>();
  const [registredStudents, setRegistredStudents] = useState<any>();
  const [registredStudentsBigOne, setRegistredStudentsBigOne] = useState<any>();

  const [isDrawerChallenge, setIsDrawerChallenge] = useState<boolean>(false);
  const [drawerConfirm, setDrawerConfirm] = useState<boolean>(false);
  const [tempsChallenge, setTempsChallenge] = useState<number>(0);
  const [getAllQuizz, { data, isLoading: isLoadingQuiz, isError }] = useGetAllQuizzMutation();
  const submit = useRef<any>(null);
  const [tempTopic, setTempTopic] = useState<any>();

  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setcurrentPage] = useState<any>(1);
  const [currentQuizPage, setcurrentQuuizPage] = useState<any>(1);
  const [selectedTeacher, setSelectedTeacher] = useState<any>(null);
  const [price, setPrice] = useState<any>();
  const [cost, setCost] = useState<any>();
  const [date, setDate] = useState<Moment | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [teachersList, setTeachersList] = useState<any>([]);

  const refSubmiteBtn = useRef<any>(null);
  const [page, setPages] = useState<any>(1);
  const [totalPages, setTotalPages] = useState<any>(1);

  const [userLevels, setUserLevels] = useState<any[]>([]);
  const [activeStudentId, setActiveStudentId] = useState<string | null>(null);
  const [activeConfirmStudentId, setActiveConfirmStudentId] = useState<string | null>(null);

  const popoverReportRef = useRef<HTMLDivElement>(null);
  const [studentId, setStudentId] = useState();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const filterChallenges = (value: string) => {
    if (value !== undefined) {
      const filtered = value
        ? filteredChallenges.filter((challenge: any) =>
          challenge.title?.toLowerCase().includes(value.toLowerCase())
        )
        : challengesHistory;
      setFilteredChallenges(filtered);
    }
  }

  const handleReserve = () => {
    setShowDrawerCreProf(true);
  };

  const handleSendMessage = () => {
    const findRoomBody = {
      actor1: user?._id,
      actor2: classData?.teacher?._id,
      flag: FLAGS.SINGLE_FLAG,
      instaprof: "",
      type: "",
    };

    findRoom(findRoomBody);
    dispatch(setChatReceiverId(classData?.teacher?._id));
  };

  const handleSendCollectifMessage = () => {
    const findRoomBody = {
      actor1: user?._id,
      actor2: id,
      flag: FLAGS.GROUP_FLAG,
      instaprof: "",
      type: "",
    };

    findRoom(findRoomBody);
    dispatch(setChatReceiverId(id));
  };

  const handleSendOrganismMessage = () => {
    const findRoomBody = {
      actor1: user?._id,
      actor2: classData?.organism?._id,
      flag: FLAGS.SINGLE_FLAG,
      instaprof: "",
      type: "",
    };

    findRoom(findRoomBody);
    dispatch(setChatReceiverId(classData?.organism?._id));
  };

  const handleSendStudentMessage = () => {
    const findRoomBody = {
      actor1: user?._id,
      actor2: studentId,
      flag: FLAGS.SINGLE_FLAG,
      instaprof: "",
      type: "",
    };

    findRoom(findRoomBody);
    dispatch(setChatReceiverId(studentId));
  };

  const fetchPublicationByClass = async (idClasse: string | undefined) => {
    try {
      const response = await ROOMS_SERVICES.fetchPublicationByClass(idClasse, page);
      if (response?.statusCode === StatusCode.OK) {
        setPublicationData(response?.data);
        dispatch(setIsContributionUpdated(false));
      }
    } catch (error: any) { }
  }

  const fetchClasse = useCallback(async (id: string | undefined) => {
    try {
      setLoading(true);
      const response = await ROOMS_SERVICES.findOne(id);
      if (response?.statusCode === StatusCode.OK) {
        setClassData(response.data);
        setStudentsData(response?.data?.registeredStudents);
        setFilteredStudents(response?.data?.registeredStudents);
        dispatch(setNewInvitationSent(false));
      }
    } catch (error: any) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const ReFetchClasse = useCallback(async () => {
    try {
      const response = await ROOMS_SERVICES.findOne(id);
      if (response?.statusCode === StatusCode.OK) {
        setClassData(response.data);
        setStudentsData(response?.data?.registeredStudents);
        setFilteredStudents(response?.data?.registeredStudents);
        dispatch(setNewInvitationSent(false));
      }
    } catch (error: any) {
      console.log(error);
    }
  }, [id]);

  const fetchChallengesByIdClass = useCallback(
    async (id: string | undefined) => {
      try {
        const response = await CHALLENGES_SERVICES.findByIdClasse(id);
        if (response?.statusCode === StatusCode.OK) {
          setChallenge(response?.data);
        }
      } catch (error: any) { }
    },
    []
  );

  const fetchChallengesHistory = useCallback(
    async () => {
      try {
        const response = await CHALLENGES_SERVICES.fetchChallengesHistory(id);
        if (response?.statusCode === StatusCode.OK) {
          setChallengesHistory(response?.data);
          setFilteredChallenges(response?.data);
          setIsDrawerChallengesHistoryVisible(true);
        }
      } catch (error: any) { }
    },
    [id]
  );

  const fetchPieStatsByIdClass = useCallback(async (id: string | undefined) => {
    try {
      const response = await CHALLENGES_SERVICES.getPieStatsByIdClasse(id);
      if (response?.statusCode === StatusCode.OK) {
        const data = response?.data;
        setPieData(response?.data);
      }
    } catch (error: any) { }
  }, []);

  const fetchBarStatsByIdClass = useCallback(async (id: string | undefined) => {
    try {
      const response = await CHALLENGES_SERVICES.getBarStatsByIdClasse(id);
      if (response?.statusCode === StatusCode.OK) {
        const data = response?.data;
        setBarData(
          data?.flatMap((e: any) => [
            { name: e.name, value: e.participation },
            { name: "Stat 2", value: 100 - e.participation }
          ])
        );
        setChallengePercentage(
          data?.flatMap((e: any) => {
            return e.participation
          })
        );
      }
    } catch (error: any) { }
  }, []);

  const fetchClassementByChallenge = useCallback(
    async (id: string | undefined) => {
      try {
        const response = await CHALLENGES_SERVICES.fetchClassementByChallengee(
          id
        );
        if (response?.statusCode === 200) {
          setRegistredStudents(studentParser(response.data));
          setRegistredStudentsBigOne(studentParser(response.data));
        }
      } catch (error: any) { }
    },
    []
  );

  const getTeachers = async () => {
    try {
      setIsLoading(true);
      setTeachersList([]);
      const res = await AUTH_SERVICES.getAllTeachers(currentPage);
      if (res?.data) {
        setTeachersList(res.data.result);
        setTotalPages(res.data?.totalPages);
      } else {
        throw new Error("Error");
      }
    } catch (error) { }
    finally {
      setIsLoading(false);
    }
  }

  const getTeacher = async () => {
    try {
      setIsLoading(true);
      setTeachersList([]);
      const res = await AUTH_SERVICES.getTeacher(currentPage, searchValue);
      if (res?.data) {
        setTeachersList(res.data.result);
        setTotalPages(res.data?.totalPages);
      } else {
        throw new Error("Error");
      }
    } catch (error) { }
    finally {
      setIsLoading(false);
    }
  }

  const handleInviteStudent = () => {
    setShowAddClasse(true);
  }

  const handleAddTeacher = () => {
    setIsDrawerVisible(true);
  }

  const handleSearchChange = (e: any) => {
    setSearchValue(e.target.value);
    if (e.target.value.length > 0) {
      const filterTeacher = teachersList.filter((item: any) =>
        item?.teacher.firstname.toLowerCase().includes(e.target.value.toLowerCase()) ||
        item?.teacher.lastname.toLowerCase().includes(e.target.value.toLowerCase()) ||
        item?.teacher.email.toLowerCase().includes(e.target.value.toLowerCase())
      );
      if (filterTeacher.length !== 0) {
        setTeachersList(filterTeacher);
      }
      else {
        console.log("here");
        setcurrentPage(1);
        getTeacher();
      }
    }
    else {
      getTeachers();
    }
  };

  const handleShowHistory = () => {
    setOpenDrawerHistorique(true);
  };

  const handleAddAvailability = () => {
    dispatch(displayDrawerAdsSpecific(true));
  };

  const handleAddPublication = () => {
    setOpenDrawerPublications(true);
  };

  const handleSelectChallenge = (id: string) => {
    fetchPieStatsByIdClass(id);
    fetchBarStatsByIdClass(id);
    fetchClassementByChallenge(id);
  };

  const startChallenge = async () => {
    setIsDrawerChallenge(true);
  };

  const handleShowStudents = () => {
    setIsDrawerStudentsVisible(true);
  }

  const stopChallenge = async (challengeId: string) => {
    try {
      if (user?._id && challengeId) {
        const response = await CHALLENGE_SERVICES.stopChallenge(challengeId, user?._id);
        if (response?.statusCode === StatusCode.CREATED) {
          window.location.reload();
        }
      }
    } catch (error) {
      message.error("Erreur survenue lors de l'arrêt du challenge.");
    }
  };

  const [form] = Form.useForm();

  const filterQuiz = useCallback(async (values: any) => {
    if (values?.levelId === undefined) {
      values.topicId = undefined
      form.setFieldsValue({
        ['topicId']: undefined,
      });
    }
    await getAllQuizz(values);
  }, []);

  const onReset = () => {
    form.resetFields();
    getAllQuizz({
      title: "",
      levelId: "",
      topicId: "",
      status: "",
      self: false,
      page: 1,
      duration: "",
      quizzLevel: ""
    } as Icourses);
  };

  const OnSelectLevel = useCallback(
    async (levelId: any) => {
      if (levelId) {
        const response = await TOPICS_SERVICES.findAll(levelId);
        if (response?.statusCode === StatusCode.OK) {
          setTempTopic(response?.data);
          form.setFieldsValue({
            ['topicId']: undefined,
          });
          //call static get quizz
          getAllQuizz({
            title: form.getFieldValue('title') === undefined ? "" : form.getFieldValue('title'),
            levelId: levelId,
            topicId: "",
            status: "",
            self: false,
            page: currentPage,
            duration: form.getFieldValue('duration') === undefined ? "" : form.getFieldValue('duration'),
            quizzLevel: form.getFieldValue('quizzLevel') === undefined ? "" : form.getFieldValue('quizzLevel')
          } as Icourses);
        }
      }
    },
    [tempTopic]
  );

  const OnSubmitChallengeHandler = (infos: any) => {
    setChallenge(infos);
  };

  const getLevelById = useCallback(async (idLevel: any) => {
    try {
      if (!idLevel) return null;

      const response = await findLevelsById(idLevel);
      if (response.statusCode === StatusCode.OK) {
        return response.data?.title;
      }
    } catch (error) {
      console.error(error);
    }
    return null;
  }, []);

  const handleFilteringStudents = (e: any) => {

    const value = e.target.value.toLowerCase();

    if (value !== undefined) {
      const filtered = value
        ? filteredStudents.filter((data: any) =>
          data?.student.firstname?.toLowerCase().includes(value) ||
          data?.student.lastname?.toLowerCase().includes(value)
        )
        : studentsData;

      setFilteredStudents(filtered);
    }
  };

  const handleDeleteStudent = async (id: string) => {
    setIsLoading(true);
    try {
      setIsLoading(true);
      const response = await ROOMS_SERVICES.removeStudentFromClass(data?.accessCode, id);
      if (response?.statusCode === StatusCode.OK) {
        setFilteredStudents((prev: any[]) =>
          prev?.filter((data: any) => data?.student._id !== id)
        );
        message.success("Élève supprimé avec succès.");
        setActiveStudentId(null);
        fetchClasse(id);
      }
    } catch (error: any) {
      console.log(error);
      message.warning("Erreur survenue lors de la suppression, merci de réessayer.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    setTimeout(() => {
      if (popoverReportRef.current && !popoverReportRef.current.contains(event.target as Node)) {
        if (activeConfirmStudentId) {
          console.log("Action selected!");
        } else {
          setActiveStudentId(null);
        }
      }
    }, 200);
  };

  const content = (
    <div onClick={(e) => e.stopPropagation()}>
      <div onClick={handleSendStudentMessage} style={{ fontSize: "1em", height: "30px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", gap: "10px", cursor: "pointer" }}><img src={MessageIcon} height={12}></img> Message</div>
      {!classData?.isCollective && <div onClick={() => { setActiveConfirmStudentId(activeStudentId) }} style={{ fontSize: "1em", color: "#F56666", height: "30px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", gap: "10px", cursor: "pointer" }}><img src={Delete} height={12}></img> Supprimer</div>}
    </div>
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeConfirmStudentId]);

  useEffect(() => {
    if (!isLoading) {
      setActiveConfirmStudentId(null);
    }
  }, [isLoading]);

  useEffect(() => {
    if (!filteredStudents?.length) return;

    const fetchLevels = async () => {
      const levels = await Promise.all(
        filteredStudents.map(async (data: any) => {
          const levelTitle = await getLevelById(data?.student?.levelId);
          return {
            studentId: data?.student._id,
            level: levelTitle,
          };
        })
      );

      setUserLevels((prev) => [...prev, ...levels]);
    };

    fetchLevels();
  }, [filteredStudents, getLevelById]);

  useEffect(() => {
    fetchClasse(id);
  }, [id]);

  useEffect(() => {
    if (newInvitationSent) {
      fetchClasse(id);
    }
  }, [newInvitationSent]);

  useEffect(() => {
    getTeachers();
  }, [user]);

  useEffect(() => {
    getTeachers();
  }, [currentPage]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(setSelectUserChat(true));
      dispatch(toggleAppChat(true));
    }
  }, [isSuccess]);

  useEffect(() => {
    if (id) {
      fetchClasse(id);
      fetchChallengesByIdClass(id);
    }
  }, [id]);

  useEffect(() => {
    if (id && classData) {
      fetchPublicationByClass(id);
    }
  }, [id, classData]);

  useEffect(() => {
    if (id && classData && isContributionUpdated) {
      fetchPublicationByClass(id);
    }
  }, [id, classData, isContributionUpdated]);

  useEffect(() => {
    if (challenge) {
      fetchPieStatsByIdClass(challenge?._id);
      fetchBarStatsByIdClass(challenge?._id);
      fetchClassementByChallenge(challenge?._id);
    }
  }, [challenge]);

  useEffect(() => {
    getAllQuizz({
      title: "",
      levelId: "",
      topicId: "",
      status: "",
      self: false,
      page: currentQuizPage,
      duration: "",
      quizzLevel: ""
    } as Icourses);
    window.scrollTo(0, 0);
  }, [currentQuizPage]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'reservations':
        return (
          !loading && <GroupClassesContent
            data={classData}
            students={filteredStudents}
            viewType="studentCalendarBooking"
            publicationData={publicationData}
            onInviteStudent={handleInviteStudent}
            onShowHistory={handleShowHistory}
            onAddPublication={handleAddPublication}
            onNewAction={ReFetchClasse}
          />
        );
      case 'propositions':
        return (
          !loading && <GroupClassesContent
            data={classData}
            students={filteredStudents}
            viewType="coursesPropositions"
            publicationData={publicationData}
            onInviteStudent={handleInviteStudent}
            onShowHistory={handleShowHistory}
            onAddPublication={handleAddPublication}
          />
        );
      case 'publications':
        return (
          !loading && <GroupClassesContent
            data={classData}
            students={filteredStudents}
            viewType="publications"
            publicationData={publicationData}
            onInviteStudent={handleInviteStudent}
            onShowHistory={handleShowHistory}
            onAddPublication={handleAddPublication}
          />
        );
      case 'challenges':
        return (
          !loading && <GroupClassesContent
            data={classData}
            students={filteredStudents}
            viewType="challenges"
            publicationData={publicationData}
            onInviteStudent={handleInviteStudent}
            onShowHistory={handleShowHistory}
            onAddPublication={handleAddPublication}
            onSelectChallenge={handleSelectChallenge}
            pieData={pieData}
            barData={barData}
            challenges={challenges}
            challengePercentage={challengePercentage}
            challengeStudents={registredStudents}
            onDisplayChallengesHistory={fetchChallengesHistory}
          />
        );
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      <div style={{ marginTop: "0px", marginBottom: "7em" }}>
        {!isMobile && <Breadcrumbs isClassroom />}
        <AppScreen>
          <div className="main">
            <div className="content">
              <ClassroomHeader data={classData} className={classData?.title} onReserve={handleReserve} onAddAvailability={handleAddAvailability} onAddPublication={handleAddPublication} />
              <div className="main-content">
                <NavigationTabs activeTab={activeTab} onChange={setActiveTab} data={classData}>
                  {renderTabContent()}
                </NavigationTabs>
              </div>
            </div>

            <div className="sidebar">
              <ClassroomSidebar
                data={classData}
                challenge={challenge}
                onSendMessage={handleSendMessage}
                onSendCollectifMessage={handleSendCollectifMessage}
                onSendOrganismMessage={handleSendOrganismMessage}
                onAddTeacher={handleAddTeacher}
                onStartChallenge={startChallenge}
                onStopChallenge={stopChallenge}
                onShowStudents={handleShowStudents}
              />
            </div>
          </div>

          {/* Drawer Historique des challenges */}
          <Drawer
            className="drawer"
            placement="right"
            onClose={() => setIsDrawerChallengesHistoryVisible(false)}
            visible={isDrawerChallengesHistoryVisible}
            width={isMobile ? "100%" : "65%"}
            title={
              <div style={{ fontSize: isMobile ? "0.8em" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent", display: "flex", flexDirection: "row", alignItems: "center", gap: "30px" }}>
                Historique des challenges
                <div className="search-box">
                  <Input
                    placeholder="Chercher ..."
                    onChange={(e) => filterChallenges(e.target.value)}
                    bordered={false}
                    suffix={<img src={IconSearch} height={15} />}
                  />
                </div>
              </div>
            }
            headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
            closeIcon={
              <img
                src={ArrowBack}
                height={isMobile ? 10 : 18}
                style={{}}
              ></img>
            }
            drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "50px", borderBottomLeftRadius: isMobile ? "0px" : "50px", boxShadow: "-3px 3px 34px #39393929" }}
            bodyStyle={{ zIndex: "1" }}
          >
            <div style={{ marginLeft: "5%", marginRight: "5%", }}>
              {filteredChallenges.map((challenge: any) => (
                <div key={challenge?._id} className="challenge-row">
                  <div className="challenge-info">
                    <span className="challenge-title">
                      {challenge?.title}
                    </span>
                    <span className="challenge-date">
                      {new Date(challenge?.createdAt).toLocaleDateString("fr-FR", {
                        weekday: "long",
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}
                    </span>
                  </div>

                  {/* <button className="action-btn">Action</button> */}
                </div>
              ))}
            </div>
          </Drawer>

          {/* Student Courses History */}
          <DrawerHistorique
            open={openDrawerHistorique}
            setOpen={setOpenDrawerHistorique}
            user={user}
          />

          {/* Drawer Students  */}
          <Drawer
            className="drawer"
            placement="right"
            onClose={() => {
              setIsDrawerStudentsVisible(false);
              setActiveStudentId(null);
              setActiveConfirmStudentId(null);
            }}
            visible={isDrawerStudentsVisible}
            width={isMobile ? "100%" : "80%"}
            title={
              <div style={{ fontSize: isMobile ? "0.8em" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent", display: "flex", flexDirection: "row", alignItems: "center", gap: "30px" }}>
                Mes élèves
                <div className="search-box">
                  <Input
                    placeholder="Chercher ..."
                    onChange={handleFilteringStudents}
                    bordered={false}
                    suffix={<img src={IconSearch} height={15} />}
                  />
                </div>
              </div>
            }
            headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
            closeIcon={
              <img
                src={ArrowBack}
                height={isMobile ? 10 : 18}
                style={{}}
              ></img>
            }
            drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "50px", borderBottomLeftRadius: isMobile ? "0px" : "50px", boxShadow: "-3px 3px 34px #39393929" }}
            bodyStyle={{ zIndex: "1" }}
          >
            <div style={{ marginLeft: "5%", marginRight: "5%", }}>
              {filteredStudents.map((data: any, index: number) => (
                <div key={data?.student?._id} className="student-row">
                  <div className="student-info">
                    <div className="student-info-avatar-name">
                      <img src={data?.student?.profile} height={50} />
                      <span className="student-title">
                        {data?.student?.firstname + " " + data?.student?.lastname}
                      </span>
                    </div>
                    <div className="student-school">{data?.student?.etablissement}</div>
                    <div className="student-level">{userLevels[index]?.level}</div>
                  </div>

                  <Popover
                    className="customPopoverStudent"
                    visible={activeStudentId === data?.student?._id}
                    placement="left"
                    content={content}
                    trigger="click"
                    onVisibleChange={(open) => {
                      if (!open) setActiveStudentId(null);
                    }}
                  >
                    <div ref={popoverReportRef} className="optionButtonStudent" onClick={(e) => {
                      e.stopPropagation();
                      setStudentId(data?.student._id);
                      setActiveStudentId((prev) =>
                        prev === data?.student._id ? null : data?.student._id
                      );
                    }}>
                      <img src={MoreOptions} height={10} style={{ marginRight: "5px" }}></img>
                      Options
                    </div>
                  </Popover>

                  <Popconfirm
                    placement="top"
                    title="Veux-tu vraiment supprimer cet élève ?"
                    visible={activeConfirmStudentId === data?.student?._id}
                    onConfirm={() => {
                      handleDeleteStudent(data?.student._id);
                      setActiveConfirmStudentId(null);
                    }}
                    onCancel={() => setActiveConfirmStudentId(null)}
                    okText={isLoading ? <Spin size="small" /> : "Oui"}
                    cancelText="Non"
                    okButtonProps={{ disabled: isLoading }}
                  >
                    <Button style={{ visibility: "hidden" }}></Button>
                  </Popconfirm>
                </div>
              ))}
            </div>
          </Drawer>
        </AppScreen>
      </div>
    </React.Fragment>
  );
};

export default Room;